import { createUnavailableProvider, type EvidenceProvider } from "./evidence";

/**
 * Declared evidence sources (spec §26D).
 *
 * The sources Berrier Reno intends to have are declared here even before
 * they exist, for the same reason the sourcing boundary declares Home
 * Depot's real limitations: a seam that is written down is a seam that
 * cannot be quietly bypassed, and the UI can say what a future source would
 * add without anything pretending the data is already there.
 *
 * NOTHING here calls a network service. Building the Berrier Reno network
 * backend is a separate, later phase with its own privacy and anonymization
 * design; these providers return no evidence and say why.
 */

/**
 * FUTURE: anonymized cost observations contributed by other Berrier Reno
 * organizations, aggregated by market. Contributing is opt-in and the data
 * is aggregate, never a competitor's job records (spec §26D).
 */
export function networkMarketProvider(): EvidenceProvider {
  return createUnavailableProvider(
    "network-market",
    "Berrier Reno network",
    "network-market",
    "Anonymized market data from other Berrier Reno organizations is not available yet. When it is, contributing will be opt-in and the data aggregate.",
  );
}

/**
 * FUTURE: third-party regional construction cost data (published unit-cost
 * databases). A licensed feed, behind the same interface.
 */
export function regionalCostDataProvider(): EvidenceProvider {
  return createUnavailableProvider(
    "regional-cost-data",
    "Regional cost data",
    "network-market",
    "No regional cost-data subscription is configured. Berrier Reno will not fabricate regional averages.",
  );
}

/** The declared-but-unbuilt providers, in the order they would rank. */
export function futureEvidenceProviders(): EvidenceProvider[] {
  return [networkMarketProvider(), regionalCostDataProvider()];
}
